$.fn.datepicker.dates.pl = {
    days: ["Niedziela", "Poniedziałek", "Wtorek", "Środa", "Czwartek", "Piątek", "Sobota"],
    daysShort: ["Niedz.", "Pon.", "Wt.", "Śr.", "Czw.", "Piąt.", "Sob."],
    daysMin: ["Nd", "Pn", "Wt", "Śr", "Cz", "Pt", "Sb"],
    months: ["Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec", "Lipiec", "Sierpień", "Wrzesień", "Październik", "Listopad", "Grudzień"],
    monthsShort: ["Sty.", "Lut.", "Mar.", "Kwi.", "Maj", "Cze.", "Lip.", "Sie.", "Wrz.", "Paź.", "Lis.", "Gru."],
    today: "Dzisiaj",
    weekStart: 1,
    clear: "Wyczyść",
    format: "dd.mm.yyyy"
};


function replaceSliderContent(swiper){
    var targetSlideIndex = swiper.activeIndex,
        targetSlide = swiper.slides[targetSlideIndex],
        targetSlideContent = $(targetSlide).find('.slide-content').html(),
        sliderContent = $(swiper.container).next().find('.slider-content');

    if (targetSlideContent === undefined) targetSlideContent = ('');

    sliderContent.fadeOut("fast", function(){
        $(this).html(targetSlideContent);
        sliderContent.fadeIn("fast");
    });
}

Language = {

    _lang: {
        'pl': {
            of: 'z',
            close: 'Zamknij',
            next: 'Następne',
            prev: 'Poprzednie',
            start: 'Start',
            pause: 'Pauza',
            image_error: 'Nie udało się wczytać zdjęcia'
        },
        'cs': {
            of: 'z',
            close: 'Zamknij',
            next: 'Następne',
            prev: 'Poprzednie',
            start: 'Start',
            pause: 'Pauza',
            image_error: 'Nie udało się wczytać zdjęcia'
        },
        'en': {
            of: 'of',
            close: 'Close',
            next: 'Next',
            prev: 'Previous',
            start: 'Start',
            pause: 'Pause',
            image_error: 'Failed to load image'
        }
    },

    get: function(key) {
        var dict = Language._lang[Language.currentLang];
        if (dict === undefined || dict[key] === undefined) {
            return key;
        }
        return dict[key];
    },


    currentLang: 'pl',
    of: function() { return Language.get('of'); },
    close: function() { return Language.get('close'); },
    next: function() { return Language.get('next'); },
    prev: function() { return Language.get('prev'); },
    start: function() { return Language.get('start'); },
    pause: function() { return Language.get('pause'); },
    error: function() { return Language.get('image_error'); },


    init : function(lang) {
        Language.currentLang = lang;
    },
};

var FontSize = {

    size: ['font-regular', 'font-medium', 'font-large'],

    init: function () {
        $('header .icon-font-size').click(function () {

            var fontClass = Cookies.get('font-class');
            if (fontClass == undefined) {
                fontClass = FontSize.size[0];
            }
            $('html').removeClass(fontClass);
            var index = FontSize.size.indexOf(fontClass);
            index ++;
            if (index >= FontSize.size.length) {
                index = 0;
            }
            if (index == 0) {
                Cookies.remove('font-class');
            } else {
                var newClass = FontSize.size[index];
                $('html').addClass(newClass);
                Cookies.set('font-class', newClass, {expires: 300});
            }

        });
    }
};

var Theme = {

    isDarker: function () {
        var cookie = Cookies.get('theme-class');
        return cookie !== undefined && cookie !=='';
    },
    init: function () {
        $('header .icon-eye').click(function () {

            var themeClass = 'darker';
            var current = Cookies.get('theme-class');
            if (current === undefined || current != themeClass) {
                current = themeClass;
                $('html').addClass(themeClass);
                Cookies.set('theme-class', current, {expires: 300});
            } else {
                $('html').removeClass(themeClass);
                Cookies.remove('theme-class');
            }

        });
    }
};

Site = {

    language: null,
    init: function (l) {

        Language.init(l);
        Site.language = Language;

        Site.inlineDatePicker = $('.datepicker-inline').datepicker({
            // container: '.form-group.date',
            language: Site.language.currentLang,
            templates: {
                leftArrow: '<i class="icon-chevron-left"></i>',
                rightArrow: '<i class="icon-chevron-right"></i>'
            },
            beforeShowDay: function(date){
                var d = date;
                var curr_date = d.getDate();
                var curr_month = d.getMonth() + 1;
                var curr_year = d.getFullYear();
                var formattedDate = curr_date + "/" + curr_month + "/" + curr_year;

                if ($.inArray(formattedDate, Site.inlineCalendarDates) != -1){
                    return {
                        classes: 'highlighted'
                    };
                }
                return;
            }
        });

        Site.detailsViewSlider = new Swiper('.details-view-slider .swiper-container', {
            nextButton: '.details-view-slider .button-next',
            prevButton: '.details-view-slider .button-prev',
        });

        Site.gallerySlider =  new Swiper('.gallery-slider', {
            nextButton: '.gallery-carousel-container .button-next',
            prevButton: '.gallery-carousel-container .button-prev',
            slidesPerView: 2,
            spaceBetween: 30,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            breakpoints: {
                992: {
                    slidesPerView: 2,
                },
                580: {
                    slidesPerView: 1,
                }
            }
        });

        Site.moviesSlider =  new Swiper('#movies-slider', {
            nextButton: '.gallery-carousel-container .button-next',
            prevButton: '.gallery-carousel-container .button-prev',
            slidesPerView: 2,
            spaceBetween: 30,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            breakpoints: {
                992: {
                    slidesPerView: 2,
                },
                580: {
                    slidesPerView: 1,
                }
            }
        });


        Site.mainSlider = new Swiper('.main-slider .swiper-container', {
            nextButton: '.main-slider .button-next',
            prevButton: '.main-slider .button-prev',
            pagination: '.main-slider .pagination',
            paginationClickable: true,
            onInit: function (swiper) {
                replaceSliderContent(swiper);
            },
            onSlideChangeStart: function (swiper) {
                replaceSliderContent(swiper);
            }
        });

        Site.relatedEventsSlider = new Swiper('.related-events-slider-container .swiper-container', {
            nextButton: '.related-events-slider-container .button-next',
            prevButton: '.related-events-slider-container .button-prev',
            slidesPerView: 4,
            spaceBetween: 15,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            breakpoints: {
                992: {
                    slidesPerView: 3,
                },
                580: {
                    slidesPerView: 2,
                },
                420: {
                    slidesPerView: 1,
                }
            }
        });

        Site.eventsSlider = new Swiper('.events-slider-section .events-slider', {
            nextButton: '.events-slider-container .button-next',
            prevButton: '.events-slider-container .button-prev',
            slidesPerView: 3,
            spaceBetween: 15,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            breakpoints: {
                992: {
                    slidesPerView: 2,
                },
                580: {
                    slidesPerView: 1,
                }
            }
        });


        var lightcase =  $('a[data-rel^=lightcase]').lightcase({
            transition: 'scrollHorizontal',
            transitionOpen: 'elastic',
            transitionClose: 'elastic',
            labels: {
                'errorMessage': Site.language.error(),
                'sequenceInfo.of': ' ' + Site.language.of() + ' ',
                'close': Site.language.close(),
                'navigator.prev': Site.language.prev(),
                'navigator.next': Site.language.next(),
                'navigator.play': Site.language.start(),
                'navigator.pause': Site.language.pause()
            },
        });

        FontSize.init();
        Theme.init();

        if (Site.afterInit != null) {
            Site.afterInit();
        }

    },

    inlineDatePicker: null,

    mainSlider: null,

    eventsSlider: null,

    relatedEventsSlider: null,

    moviesSlider: null,
    gallerySlider: null,
    detailsViewSlider: null,

    inlineCalendarDates: [],
    afterInit: null,
};

$(document).ready(function(){

    $('.google-map').tsgmap();
    $('.selectpicker').selectpicker();
    $('.selectpicker').on('change', function(){
        var selected = $(this).find("option:selected").val();
        if (selected.length > 0) {
            document.location = selected;
        }
    });

    $(document).on('click', '.date i', function(){
        $(this).prev('input.datepicker').focus();
    });

    $(document).on('click', '#hamburger', function(){
        $('body').toggleClass('menu-open');
    });

});


